/*
 * Click buttons to toggle classes on some elements, maybe including the
 * clicked button itself
 *
 * Example
 *
 * HTML
 *
 * <div class="js_someTargetClass1">...</div>
 * <div class="js_someTargetClass1">...</div>
 * <div class="js_someTargetClass2">...</div>
 *
 * <button class="js_someButtonClass">Toggle</button>
 * <button class="js_someButtonClass">Toggle</button>
 * 
 * Javascript
 *
 * toggle({
 *     buttonClasses: {
 *         hookClass: 'js_someButtonClass',
 *         toggleClass: 'button--toggled',
 *     },
 *     targetClassesList: [
 *         {
 *             hookClass: 'js_someTargetClass1',
 *             toggleClass: 'highlight',
 *         },
 *         {
 *             hookClass: 'js_someTargetClass2',
 *             toggleClass: 'slide',
 *         }
 *     ],
 *     callback: function(button) {
 *         console.log(button);
 *     }
 * })
 *
 * When either button is clicked, the 'highlight' class will be toggled on both
 * div's with class 'js_someTargetClass1' and the 'slide' class will be toggled
 * on the div with class 'js_someTargetClass2'
 *
 * Additionally, the class 'button--toggled' will be toggled on the button that
 * was clicked only
 *
 * After the classes have been toggled the callback function will console log
 * the button element that was clicked
 *
 * Data attributes can be used for further namespacing. For example:
 *
 * <div class="js_someTargetClass1" data-toggle-target-of="apples">...</div>
 * <div class="js_someTargetClass1" data-toggle-target-of="oranges">...</div>
 * <div class="js_someTargetClass1">...</div>
 * <div class="js_someTargetClass2" data-toggle-target-of="apples">...</div>
 *
 * <button class="js_someButtonClass" data-toggle-target-for="apples">Toggle</button>
 * <button class="js_someButtonClass">Toggle</button>
 *
 * When the first button is clicked the second and third div's will be ignored
 *
 * When the second button is clicked, only the third div will be toggled
 *
 */

function toggleElement(target, classes) {
    target.classList.toggle(classes.toggleClass);
}

function toggleTargets(button, targetClasses) {
    let selector = '.' + targetClasses.hookClass;
    const targetId = button.getAttribute('data-toggle-for-target');

    if (targetId !== null && targetId !== '') {
        selector = selector + `[data-toggle-target-of="${targetId}"]`;
    }

    const targets = [...document.querySelectorAll(selector)];

    targets.forEach(target => toggleElement(target, targetClasses));
}

function toggle(button, buttonClasses, targetClassesList, callback) {

    if (buttonClasses.toggleClass) {
        toggleElement(button, buttonClasses);
    }

    targetClassesList.forEach(targetClasses => toggleTargets(button, targetClasses));

    if (callback instanceof Function) {
        callback(button);
    }
}

function init({ buttonClasses, targetClassesList, callback }) {
    $(document).ready(() => {
        const buttons = [...document.querySelectorAll('.' + buttonClasses.hookClass)];

        buttons.forEach(button => button.addEventListener('click', e => toggle(button, buttonClasses, targetClassesList, callback)));
    });
}

export default init;
